class SiteMenu {
    constructor($) {
        // this.init();
        this.window = $(window);
        this.doc = $(document);
        this.prevent = false;
        this.body = $('body');
        this.init($);
    }

    init($) {
        this.toggleNav($);
        this.smoothScroll($);
        this.topLoginBox($);
        this.scrollChange();
    }

    toggleNav($) {
        let searchFormField = $('#searchform input[name="s"], #searchform2 input[name="s"]');

        $('.m-overlay, .js-menu-trigger').click((e) => {
            e.preventDefault();

            if (!this.prevent) {
                this.body.toggleClass('m-open');
                this.prevent = !this.prevent;

                setTimeout(() => {
                    this.prevent = !this.prevent;
                }, 400);
            }

            if ($(e.target).hasClass('js-focus-search')) {
                setTimeout(() => {
                    searchFormField.focus();
                }, 500);
            }
        });

        $('.submenu-trigger').click(function () {
            var $submenu       = $(this).next();
            var $submenuHeight = $submenu.find('.right').outerHeight() + 20;
            var $parent        = $(this).parent();
            if ($parent.hasClass('active')) {
                $parent.removeClass('active');
                $submenu.css('max-height', 0);
            } else {
                $parent.addClass('active');
                $submenu.css('max-height', $submenuHeight);
            }
        });
    }

    scrollChange() {
        var _body = document.body;
        var saved_scroll_position = 0;
        var current_scroll_position;

        _body.classList.toggle('scroll', this.doc.scrollTop() > 50);

        function getScrollXY() {
            var scrOfX = 0, scrOfY = 0;
            if( typeof( window.pageYOffset ) == 'number' ) {
                //Netscape compliant
                scrOfY = window.pageYOffset;
                scrOfX = window.pageXOffset;
            } else if( document.body && ( document.body.scrollLeft || document.body.scrollTop ) ) {
                //DOM compliant
                scrOfY = document.body.scrollTop;
                scrOfX = document.body.scrollLeft;
            } else if( document.documentElement && ( document.documentElement.scrollLeft || document.documentElement.scrollTop ) ) {
                //IE6 standards compliant mode
                scrOfY = document.documentElement.scrollTop;
                scrOfX = document.documentElement.scrollLeft;
            }
            return [ scrOfX, scrOfY ];
        }

        function getDocHeight() {
            var D = document;
            return Math.max(
                _body.scrollHeight, D.documentElement.scrollHeight,
                _body.offsetHeight, D.documentElement.offsetHeight,
                _body.clientHeight, D.documentElement.clientHeight
            );
        }

        window.addEventListener('scroll', function () {
            current_scroll_position = window.pageYOffset;

            if (saved_scroll_position < current_scroll_position && current_scroll_position > 50) {
                _body.classList.remove('slideDown');
                _body.classList.add('slideUp');
            } else if ((saved_scroll_position > current_scroll_position) && (getDocHeight() - 50 > getScrollXY()[1] + window.innerHeight)) {
                _body.classList.remove('slideUp');
                _body.classList.add('slideDown');
            }

            saved_scroll_position = current_scroll_position;

            if (window.pageYOffset >= 50) {
                _body.classList.add('fixed-nav', 'scrolled');
            } else {
                _body.classList.remove('fixed-nav');
            }
        });
    };

    topLoginBox($) {
        let loggedInTrigger = $('.js-logged-in');
        let loggedInInfo    = $('.js-logged-in-info');

        loggedInTrigger.on('click', () => {
            loggedInInfo.toggleClass('active');
        });
    };

    smoothScroll($) {
        $('a[href^="#"]:not(.js-disable)').click(function () {
            let target = $(this.hash);
            if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname) {
                target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                if (target.length) {
                    $('html, body').stop().animate({
                        scrollTop: target.offset().top - 75
                    }, 1000);
                    // Skip to link functionality + tabindex
                    target.attr("tabindex",-1).focus();
                    return false;
                }
            }
        });

        // Do same click fn when pressing spacebar
        $('body').on('keypress','a[href^="#"]:not(.js-disable)', function(e) {
            if (e.which === 32){
                e.preventDefault();
                $(this).trigger('click');
            }
        });
    };
}

jQuery(function () {
    new SiteMenu(jQuery);
});